import React from 'react';
import fingerprintScanning from '../assets/images/scannerLoading.gif';
import '../styles/scannerloader.css'; // CSS for styling

const ScannerLoader = () => {
  return (
    <div className="overlay">
      <div className="popup-overlay">
        <div className="loader-container">
          <img src={fingerprintScanning} alt="Fingerprint Scanning" className="loader-image" loading="lazy" />
        </div>
      </div>
    </div>
  );
}

export default ScannerLoader;
